import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const BottomActionsContainer = styled.div({
  display: "flex",
  justifyContent: "flex-end",
});

export const TitleCont = styled.div({
  color:`${v.ezMainColor}`,
  fontSize:'1.2rem',
  fontWeight:'bold'
});
